import { render, staticRenderFns } from "./OversizedButton.vue?vue&type=template&id=ab2dc94a"
import script from "./OversizedButton.vue?vue&type=script&lang=js"
export * from "./OversizedButton.vue?vue&type=script&lang=js"
import style0 from "./OversizedButton.vue?vue&type=style&index=0&id=ab2dc94a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports